import React, {useState} from 'react';
import {OAuthProviderType, useOAuthLinkService,} from 'nekst-api';
import {Button, ButtonColor, ButtonSize} from 'ui-builder';
import {CardLayout, ErrorMessage} from 'features/nekst-widgets';
import googleIcon from './google.png';
import appleIcon from './apple.png';

interface ConnectOAuthButtonProps {
  provider: OAuthProviderType;
}

export default function ConnectOAuthButton({ provider }: ConnectOAuthButtonProps) {
  const [connecting, setConnecting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const oauthLinkService = useOAuthLinkService();

  const getProviderName = () => {
    switch (provider) {
      case OAuthProviderType.GOOGLE:
        return 'Google';
      case OAuthProviderType.APPLE:
        return 'Apple';
      default:
        return provider;
    }
  };

  const getProviderIcon = () => {
    switch (provider) {
      case OAuthProviderType.GOOGLE:
        return <img src={googleIcon} alt="Google" width="24" height="24" />;
      case OAuthProviderType.APPLE:
        return <img src={appleIcon} alt="Apple" width="24" height="24" />;
      default:
        return <img src={googleIcon} alt="Provider" width="24" height="24" />;
    }
  };

  const isAppleComingSoon = () => {
    return provider === OAuthProviderType.APPLE; // Change this when Apple is ready
  };

  const handleConnect = async () => {
    if (isAppleComingSoon()) {
      return;
    }

    try {
      setConnecting(true);
      setError(null);

      const oauthUrl = await oauthLinkService.getOAuthUrl(provider);
      window.location.href = oauthUrl;
    } catch (e) {
      console.error('Failed to start OAuth flow:', e);
      setError('Failed to start connection. Please try again.');
      setConnecting(false);
    }
  };


  return (
    <>
      <CardLayout
        icon={getProviderIcon()}
        title={getProviderName()}
        subtitle={
          isAppleComingSoon()
            ? 'Apple sign-in coming soon'
            : `Connect your ${getProviderName()} account for quick sign-in`
        }
        actions={
          <Button
            text={
              isAppleComingSoon()
                ? "Coming Soon"
                : connecting
                  ? "Connecting..."
                  : `Connect`
            }
            size={ButtonSize.SMALL}
            isFilled
            color={isAppleComingSoon() ? ButtonColor.GRAY : ButtonColor.GREEN}
            onClick={handleConnect}
            isDisabled={connecting || isAppleComingSoon()}
          />
        }
      />
      {error && (
        <ErrorMessage>{error}</ErrorMessage>
      )}
    </>
  );
}
